// extracted by mini-css-extract-plugin
export default {"item":"SingleNews_item__HF0I8","text_wrapper":"SingleNews_text_wrapper__K2kCR","control":"SingleNews_control__Timsz"};